import { Psychologist } from "utils/interfaces"
import { Img } from "ui-kit/components-branded/index"
import { FRIENDLY_LABELS } from "components/Labels/constants"
import { FriendlyLabelsStorage } from "components/Labels/FriendlyLabelsStorage"

interface Props {
    psy: Psychologist
}
export function FriendlyLabel({ psy }: Props) {
    const isFriendlyEnabled = FriendlyLabelsStorage.hasFriendlyLabel(FRIENDLY_LABELS.FRIENDLY)
    const isFemFriendlyEnabled = FriendlyLabelsStorage.hasFriendlyLabel(FRIENDLY_LABELS.FEM)
    const isBelieverEnabled = FriendlyLabelsStorage.hasFriendlyLabel(FRIENDLY_LABELS.BELIEVER)
    const isCancerEnabled = FriendlyLabelsStorage.hasFriendlyLabel(FRIENDLY_LABELS.CANCER)
    if (!FriendlyLabelsStorage.isAnyLabelEnabled) return null

    return (
        <>
            {isFriendlyEnabled && psy.working_with.adults.friendly && (
                <div className="labels__label">
                    <Img src="purple_heart.png" className="labels__emoji" />
                    Френдли
                </div>
            )}
            {isFemFriendlyEnabled && psy.working_with.adults.fem && (
                <div className="labels__label">
                    <Img src="woman-emoji.png" className="labels__emoji" />‍ Фем-френдли
                </div>
            )}
            {isBelieverEnabled && psy.working_with.adults.believer && (
                <div className="labels__label">
                    <Img src="church-emoji.png" className="labels__emoji" />
                    Работает с верующими
                </div>
            )}
            {isCancerEnabled && psy.working_with.adults.cancer && (
                <div className="labels__label">
                    <Img src="cancer.png" className="labels__emoji" />
                    Работает с онкопациентами
                </div>
            )}
        </>
    )
}
